
<div class="col-md-12 padding-left-0px padding-right-0px" *ngIf="mode=='view'">
  <div class="row margin-left-0px margin-right-0px">
    <div class="col-md-4 text-align-left padding-left-0px padding-right-0px">
      <label class="margin-bottom-0px font-family">{{field.Title}}</label>
    </div>
    <div class="col-md-1 padding-left-0px padding-right-0px font-weight-bold">:</div>
    <div class="col-md-7 padding-left-0px padding-right-0px">

      <label class="margin-bottom-0px font-weight-normal font-family">{{field.Value}}</label>

    </div>
  </div>


</div>

